import ApiService from '@/services/core/api.service'

const OccupationService = {
  async get (query) {
    return ApiService.get(`admin/occupations?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/occupations', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/occupations/${payload.id}`, payload)
  }
}

export default OccupationService
